import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { AttachmentWhiteIcon, PlusCircleIcon } from "Assets/icons";
import { useUploadFileMutation } from "store/services/utility";
import SingleUploadedFileDetail from "../FormComponents/SingleUploadedFileDetail";
import LoadingIndicator from "../LoadingIndicator";
import { Col } from "react-bootstrap";
import { errorMessageToast } from "helpers/common";
import { RequiredFieldAstrick } from 'components/Common/Common';
import AttachResourcesPopup from "components/Modals/AttachResourcesPopup";
import { cloneDeep } from "lodash";
import { useDeleteResourceMutation } from "store/services/resource";

const AttachDocumentsReports = ({ acl, allowedTypes = [] }) => {
  const [showResourcesPopup, setShowResourcesPopup] = useState(false);

  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const [deleteResource, { isLoading: deleteResourceLoading }] = useDeleteResourceMutation();

  const { setFieldValue, setValues, values } = useFormikContext();
console.log('VALUE OF RESOURCES', values)
  const handleFileChange = async (event, fieldName) => {
    try {
      const file = event.currentTarget.files[0];
      if (file) {
        const fileName = file.name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (allowedTypes.length && !allowedTypes.includes(fileExtension)) {
          errorMessageToast('File type not allowed!');
          return;
        }

        const response = await uploadFile({ file, acl });
        if (!response?.error) {
          let value = {
            attachment_key: response?.data,
            attachment_name: response?.data
          }
          setFieldValue(fieldName, [...(values[fieldName] || []), value]); // Append the file to the appropriate field
        }
      }
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };

  const handleRemoveFile = async (index, fieldName, setLoading) => {
    try {
      setLoading(true);
      const fieldValuesClone = cloneDeep(values[fieldName]) || [];
      const removingItem = fieldValuesClone?.[index];
  
      if (removingItem?.id) {
        await deleteResource(removingItem?.id).unwrap();
      }
  
      setValues((prevValues) => ({
        ...prevValues,
        [fieldName]: prevValues[fieldName].filter((item) => item.id !== removingItem?.id),
      }));
    } catch (err) {
      console.error("Error removing attachment", err);
    } finally {
      setLoading(false);
    }
  };
  
  const toggleResourcesPopup = () => {
    setShowResourcesPopup(!showResourcesPopup);
  }

  const handleSubmitResources = (resources) => {
    setFieldValue("resources", resources);
  }

  return (
    <>
      <AttachResourcesPopup
        show={showResourcesPopup}
        setShow={setShowResourcesPopup}
        handleSubmit={handleSubmitResources}
        defaultResources={values.resources}
      />
      <div className='d-flex mb-2'>
        <RequiredFieldAstrick />
        <span style={{ color: "#f27e97" }} className='text-capitalize'>
          Only {
            allowedTypes?.map((item, index) => {
              return index > 0 ? `   ,${item}` : item
            })
          }
          {"  "} format allowed.
        </span>
      </div>
      <div className="d-flex align-items-center gap-10">
        {/* Attach Document */}
        <label
          className="d-flex align-items-center justify-content-center commonBtn shadow-sm"
          style={{
            background: "#3DA0AA",
            borderColor: "#3DA0AA",
            minWidth: 250,
            cursor: "pointer",
          }}
        >
          <span className="icn me-2">
            <AttachmentWhiteIcon />
          </span>
          Attach Document
          <input
            type="file"
            onChange={(event) => handleFileChange(event, "documents")}
            style={{ display: "none" }}
          />
        </label>

        <span
          className="bg-white d-flex align-items-center justify-content-center rounded-pill shadow-sm position-relative"
          style={{ height: 40, width: 40, margin: "0 -20px" }}
        >
          <p className="m-0 fw-bold themeBlue">or</p>
        </span>

        {/* Attach Resources */}
        <label
          className="d-flex align-items-center justify-content-center commonBtn shadow-sm"
          style={{
            background: "#D3D905",
            borderColor: "#D3D905",
            minWidth: 250,
            cursor: "pointer",
          }}
        >
          <span className="icn me-2">
            <PlusCircleIcon />
          </span>
          Attach Resources
          {/* <input
            type="file"
            onChange={(event) => handleFileChange(event, "resources")}
            style={{ display: "none" }}
          /> */}
          <button
            style={{ opacity: 0 }}
            onClick={(e) => {
              e.preventDefault();
              toggleResourcesPopup();
            }}
          >
          </button>
        </label>
      </div>
      {isUploading && (
        <Col lg="7">
          <LoadingIndicator />
        </Col>
      )}
      <div className="mt-2">
        {/* Documents */}
        {values.documents?.length > 0 && (
          <>
            <p>Documents:</p>
            <ul className="p-0">
              {values.documents.map((res, index) => (
                <SingleUploadedFileDetail
                  key={index}
                  value={res.attachment_name}
                  handleRemoveFile={(setLoading) => handleRemoveFile(index, 'documents', setLoading)} // Remove document
                />
              ))}
            </ul>
          </>
        )}

        {/* Resources */}
        {values.resources?.length > 0 && (
          <>
            <p>Resources:</p>
            <ul className="p-0">
              {values.resources.map((res, index) => (
                <SingleUploadedFileDetail
                  key={index}
                  value={res.attachment_name}
                  handleRemoveFile={(setLoading) => handleRemoveFile(index, 'resources', setLoading)} // Remove resource
                />
              ))}
            </ul>
          </>
        )}
      </div>
    </>
  );
};

export default AttachDocumentsReports;
